<template>
  <ZigzagServiceLayout
    mainTitle="Hormone Replacement Therapy (HRT)"
    mainDescription="Personalized Care for Balance and Vitality. We provide safe, medically supervised hormone therapies for men and women to restore balance, support energy, and improve overall wellness."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'HormoneReplacementContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: "WOMEN'S HEALTH",
          title: 'Restoring Balance & Comfort',
          subtitle: 'Personalized treatment plans for female wellness.',
          paragraphs: [
            "Hormonal imbalances can deeply impact a woman's quality of life. We provide comprehensive evaluations to accurately assess your levels and craft tailored solutions.",
            "Whether you require estrogen and progesterone therapy, bioidentical hormones, or thyroid support, we are here to support your transition into menopause and ease ongoing symptoms."
          ],
          list: [
            "Estrogen & progesterone therapy",
            "Bioidentical hormone prescriptions",
            "Thyroid optimization & adrenal support",
            "Peptide therapies for vitality"
          ],
          image: '/images/services/hrt-women.png'
        },
        {
          label: "MEN'S HEALTH",
          title: 'Vitality & Testosterone',
          subtitle: 'Combat fatigue and restore your strength.',
          paragraphs: [
            "As men age, declining testosterone can cause a loss of energy, focus, and strength. Our hormonal optimization programs provide a discreet, medically-sound approach to reversing these issues.",
            "Through regular consultations and precision dosage, our male hormone plans focus on restoring vitality and boosting adrenal support to counter the effects of modern stress."
          ],
          list: [
            "Medical Testosterone Therapy",
            "Thyroid & Adrenal optimization plans",
            "Discreet treatments and consultations",
            "Peptide therapies for vitality"
          ],
          image: '/images/services/hrt-men.png'
        },
        {
          label: 'SAFETY & PROTOCOLS',
          title: 'Monitoring & Delivery Options',
          subtitle: 'Every treatment plan under strict medical supervision.',
          paragraphs: [
            "Hormone therapy is not one-size-fits-all. Every step, from the initial consultation to ongoing monitoring, is overseen by a professional.",
            "We offer a variety of delivery options including injections, slow-release pellets (3-6 months), topical creams, or oral medications, ensuring your plan is both comfortable and entirely safe."
          ],
          list: [
            "Comprehensive diagnostic lab tests",
            "Ongoing monitoring & dose adjustments",
            "Flexible delivery: Pellets, Creams, Injections",
            "Telemedicine follow-ups for convenience"
          ],
          image: '/images/services/hrt-safety.png'
        }
      ]
    };
  }
};
</script>
